import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateUtilitiesService } from '@utilities/date-utilities.service';

export function ExecutionValidator(startDate: Date, endDate: Date, dateUtils: DateUtilitiesService): ValidatorFn {
  const MILLISECONDS_IN_A_MINUTE = 60000;

  return (group: AbstractControl): ValidationErrors | null => {
    const formGroup = group as FormGroup;
    const executionDate = formGroup.get('executionDate')?.value;
    const executionTime = formGroup.get('executionTime')?.value;
    const duration = formGroup.get('duration')?.value;

    const durationControl = formGroup.get('duration');
    const executionTimeControl = formGroup.get('executionTime');

    if (durationControl) {
      const errors = { ...durationControl.errors };

      durationControl.setErrors(Object.keys(errors).length ? errors : null);
    }

    if (!executionDate && !duration) {
      return null;
    }

    const timestamp = dateUtils.combineDateTime(executionDate, executionTime);
    const start = timestamp && executionTime ? new Date(timestamp) : startDate;
    const end = new Date(start.getTime() + (duration || 0) * MILLISECONDS_IN_A_MINUTE);
    const isOutOfRange = (start < startDate || end > endDate) && (executionTime || duration);

    if (isOutOfRange) {
      if (executionTime) {
        executionTimeControl?.setErrors({ ...executionTimeControl?.errors, dateRange: true });
      }

      if (duration) {
        durationControl?.setErrors({ ...durationControl?.errors, dateRange: true });
      }

      delete executionTimeControl?.errors?.['matTimepickerMin'];
      delete executionTimeControl?.errors?.['matTimepickerMax'];
    } else {
      const executionTimeErrors = { ...executionTimeControl?.errors };
      const durationErrors = { ...durationControl?.errors };

      delete executionTimeErrors['dateRange'];
      delete executionTimeErrors['matTimepickerMax'];
      delete executionTimeErrors['matTimepickerMin'];
      delete durationErrors['dateRange'];

      executionTimeControl?.setErrors(Object.keys(executionTimeErrors).length ? executionTimeErrors : null);
      durationControl?.setErrors(Object.keys(durationErrors).length ? durationErrors : null);
    }

    return isOutOfRange ? { dateRange: true } : null;
  };
}
